export default "__VITE_ASSET__57ad8d6c__"